import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";
import { EtySchool } from "../../interfaces/entities";

const useGetSchools = () => {
    const queryFn = async (): Promise<EtySchool[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`schools`);
        return res.data?.length ? res.data : [];
    };

    return useQuery({
        queryKey: ['schools_tree'],
        queryFn,
        retry: 0,
    });
};

export default useGetSchools;